module.exports = __webpack_public_path__ + "static/media/mixer_count.89d49c4a.svg";